<template>
  <div>
    <router-view></router-view>
    <v-snackbar right :value="updateExists" :timeout="-1">
      {{$t('newVersionAvailableLabel')}}
      <v-btn small text @click="refreshApp">
        {{$t('refreshLabel')}}
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Vue from "vue";
import update from "@/mixins/update";

export default {
  name:'App',
  mixins: [update],
  created() {
    document.title = this.$t('mainNameLabel');
  },
}
</script>

<style>
  * {
    word-break: break-word !important;
  }
</style>